'use client';

import classNames from 'classnames';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { FC, ReactNode, useState } from 'react';

import { Button } from 'src/general/components/Button/Button';
import { useFormStepTransition } from 'src/general/transitions/FormStepTransition/FormStepTransition.context';

import styles from './CarMatchStartPage.module.scss';

type CarMatchStartPageProps = {
  microcopy: {
    content: ReactNode;
    buttonLabel: ReactNode;
  };
};

const CarMatch = dynamic(() => import('src/general/animations/CarMatch').then((mod) => mod.CarMatch), {
  ssr: false,
});

export const CarMatchStartPage: FC<CarMatchStartPageProps> = ({ microcopy }) => {
  const { content, buttonLabel } = microcopy;
  const { navigate } = useFormStepTransition();
  const [animationReady, setAnimationReady] = useState<boolean>(false);

  return (
    <section className={styles.root}>
      <div className={styles.animationContainer}>
        <CarMatch play loop={false} onLoad={() => setAnimationReady(true)} segments={[60, 310]} />
        <Image
          src="/images/components/CarMatchStartPage/CarMatchStart.png"
          alt=""
          width={640}
          height={464}
          priority
          className={classNames(styles.animationPlaceholder, { [styles.animationPlaceholderHidden]: animationReady })}
        />
      </div>
      <div className={styles.contentContainer}>{content}</div>
      <div className={styles.ctaContainer}>
        <Button
          variant="primary"
          size="small"
          className={styles.cta}
          onClick={() => navigate('/car-match/start')}
          data-testid="CarMatchStartPage_Component_GetStartButton"
        >
          {buttonLabel}
        </Button>
      </div>
    </section>
  );
};
